import { filterProps } from '@/utils/functional-component-utils';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

const flattenAttributes = (attributes, label, children, parent) => {
  if (attributes) {
    return attributes.reduce((result, item) => {
      let newItem = {
        id: item.id,
        label: get(item, label),
        path: [item.id, ...(parent?.path ?? [])]
      };
      return [
        ...result,
        newItem,
        ...flattenAttributes(get(item, children), label, children, newItem)
      ];
    }, []);
  } else {
    return [];
  }
};

const _sortItems = items => items?.sort((a, b) => Number(a) > Number(b));
const _byId = id => item => item.id == id;

export default {
  props: {
    itemChildren: { type: String, default: 'data.children' },
    emitChange: { type: Boolean, default: false },
    selectParents: { type: Boolean, default: true },
    itemsPending: { type: Boolean, default: false}
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.handleInput(value);
      }
    },
    flatItems() {
      return flattenAttributes(
        this.sortedItems,
        this.$props.itemText,
        this.itemChildren
      );
    },
    filterProp() {
      return filterProps(this.$props, ['items', 'value', 'menuProps']);
    },
    computedSearch: {
      set(newSearch) {
        this.search = newSearch;
      },
      get() {
        return this.search;
      }
    },
  },
  methods: {
    filterProps: filterProps,
    async handleTreeview(event) {
      if (this.itemsPending) return; 
      
      let clonedValue = cloneDeep(this.value);

      if (this.isNewItemAdded(event, clonedValue)) {
        this.internalValue = this.selectParents
          ? await this.getValueWithParents(event)
          : event;
      } else {
        let difference = clonedValue?.filter(value => !event.includes(value));
        this.internalValue = this.selectParents
          ? await this.removeByParents(event, difference)
          : event;
      }
    },
    async removeByParents(event, difference) {
      event.forEach(value => {
        let item = this.flatItems.find(_byId(value));
        if (item?.path.some(item => item == difference)) {
          event = event?.filter(item => item != value);
          return event;
        } else return event;
      });
      return event;
    },
    handleInput(event) {
      let newEvent = cloneDeep(event);
      if (this.noDataChanged(newEvent)) return;
      const sortedItems = _sortItems(newEvent);

      this.$emit('input', sortedItems);

      if (this.emitChange) {
        this.$emit('change', _sortItems(newEvent));
      }
    },
    handleActiveInput(event) {
      let itemId = event[0];
      let clonedValue = cloneDeep(this.value);

      if (clonedValue?.includes(itemId)) {
        let filterDeselected = this.internalValue?.filter(
          item => item != itemId
        );

        this.filterDeselected?.forEach(value => {
          let item = this.flatItems.find(_byId(value));
          if (item?.path.some(item => item == itemId)) {
            clonedValue?.filter(item => item != value);
          }
        });
        this.handleTreeview(filterDeselected);
      } else this.handleTreeview([...(clonedValue ?? []), itemId]);
    },
    formatItem(item) {
      return !Array.isArray(item) ? [item] : item;
    },
    async getValueWithParents(event) {
      if (event == undefined || event.length == 0) return [];

      let items = [];

      event.forEach(value => {
        let item = this.flatItems.find(_byId(value));

        item?.path.forEach(parent => {
          if (!items.some(id => id == parent)) items.push(parent);
        });
      });
      return items;
    },
    setRemainingValues(value = []){
      let val = value?.filter(val => this.flatItems?.some(item => item.id == val)) ?? [];
      this.handleTreeview(val)
    },
    /*****************
     * ### HELPERS ###
     *****************/
    isNewItemAdded(pendingSelection = [], selection = []) {
      return pendingSelection?.length > selection?.length;
    },
    isItemRemoved(pendingSelection = [], selection = []) {
      return pendingSelection?.length < selection?.length;
    },
    noDataChanged(event = []) {
      let value = cloneDeep(this.value) ?? [];

      let arr1 = _sortItems(event);
      let arr2 = _sortItems(value);

      return isEqual(arr1, arr2);
    }
  },
};
